import PropTypes from "prop-types";
import React from "react";

import Control from "../Control";

var Edit = function Edit(_ref) {
  var controlsClassNames = _ref.controlsClassNames,
      displayName = _ref.displayName,
      _onChange = _ref.onChange,
      hiddenProps = _ref.hiddenProps,
      controlsStyles = _ref.controlsStyles,
      enhancedComponent = _ref.enhancedComponent;

  var controls = Object.entries(enhancedComponent.props).sort().map(function (_ref2) {
    var name = _ref2[0],
        value = _ref2[1];
    return hiddenProps.indexOf(name) === -1 && React.createElement(Control, {
      name: name,
      value: value,
      classNames: controlsClassNames,
      styles: controlsStyles,
      onChange: function onChange(name, value, valid) {
        return _onChange(name, value, valid);
      }
    });
  });
  return React.createElement(
    "pre",
    { className: "language-jsx" },
    React.createElement(
      "span",
      { className: "token tag" },
      React.createElement(
        "span",
        { className: "token punctuation" },
        "<"
      ),
      displayName ? displayName : enhancedComponent.type.name
    ),
    controls.map(function (control, i) {
      return React.createElement(
        "div",
        { key: i },
        control
      );
    }),
    React.createElement(
      "span",
      { className: "token punctuation" },
      "/>"
    )
  );
};

Edit.propTypes = process.env.NODE_ENV !== "production" ? {
  controlsClassNames: PropTypes.shape({
    string: PropTypes.string,
    boolean: PropTypes.string,
    number: PropTypes.string
  }).isRequired,
  displayName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  hiddenProps: PropTypes.arrayOf(PropTypes.string),
  controlsStyles: PropTypes.shape({
    string: PropTypes.object,
    boolean: PropTypes.object,
    number: PropTypes.object
  }).isRequired,
  enhancedComponent: PropTypes.element.isRequired
} : {};

Edit.defaultProps = {
  controlsClassNames: {
    boolean: "",
    number: "",
    string: ""
  },
  controlsStyles: {
    boolean: {},
    number: {},
    string: {}
  },
  displayName: null,
  hiddenProps: []
};

export default Edit;